import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "-10 0 317 300"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M0 66q0-4 2.5-7T9 56h10q28 0 54 15 20 11 37 31 12 13 21 28 10-15 21-28 18-20 38-31 25-15 54-15v19q-24 0-45 12-17 10-32 27t-25 36q10 19 25 36t32 27q21 12 45 12v19q-29 0-54-15-20-11-38-31-11-13-21-28-9 15-21 28-17 20-37 31-26 15-54 15H9q-4 0-6.5-3T0 234t2.5-6.5T9 225h10q23 0 44-12 18-10 33-27t25-36q-10-19-25-36T63 87Q42 75 19 75H9q-4 0-6.5-2.5T0 66m244 36V29q0-3 2.5-4.5t4.5.5l45 37q1 1 1 3.5t-1 3.5l-45 37q-2 2-4.5.5T244 102m0 169v-73q0-3 2.5-4.5t4.5.5l45 37q1 1 1 3.5t-1 3.5l-45 37q-2 2-4.5.5T244 271"
    }, null, -1)
  ])))
}
export default { render: render }